import React, { useId } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export default function ConfirmationPopup({ open, onClose, onConfirm, title = "Confirmation", message = "Are you sure you want to continue?", confirmLabel = "Confirm", cancelLabel = "Cancel", confirmColor = "error" }) {
  const id = useId();
  return <Dialog open={open} onClose={onClose} slotProps={{ paper: { role: "alertdialog" } }} fullWidth maxWidth="xs" aria-labelledby={id + "-title"} aria-describedby={id + "-description"}>
    <DialogTitle id={id + "-title"} sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
      <Box sx={{ display: "grid", placeItems: "center", width: 40, height: 40, flexShrink: 0, borderRadius: 2, bgcolor: confirmColor === "error" ? "#FEF2F2" : "var(--primaryLight)", color: confirmColor === "error" ? "error.main" : "primary.main" }}><WarningAmberRoundedIcon /></Box>
      {title}
    </DialogTitle>
    <DialogContent><DialogContentText id={id + "-description"} sx={{ fontSize: 14, lineHeight: 1.8 }}>{message}</DialogContentText></DialogContent>
    <DialogActions>
      <Button type="button" variant="outlined" color="inherit" onClick={onClose} autoFocus>{cancelLabel}</Button>
      <Button type="button" variant="contained" color={confirmColor} onClick={onConfirm}>{confirmLabel}</Button>
    </DialogActions>
  </Dialog>;
}
